import React from "react";
import "./landscape-fourth-block.component.scoped.scss";
import { useTranslation } from "react-i18next";
import { Box } from "@material-ui/core";
import LandscapeTableCard from "../landscape-table-card/landscape-table-card.component";

export default function LandscapeFourthBlock(props: any) {
  const { openTasks } = props;
  const { t } = useTranslation();

  return (
    <Box className="cards__content mb-5">
      {openTasks.data && (
        <Box className="card__content">
          <LandscapeTableCard
            title={t(openTasks.title)}
            subTitle={t(openTasks.subTitle)}
            columns={openTasks.columns}
            tableName={openTasks.tableName}
            data={openTasks.data}
          />
        </Box>
      )}
    </Box>
  );
}
